<div
  class="switch {{ class }}"
  [class.checked]="value"
  [class.disabled]="disabled"
  (click)="toggle()"
>
  <div class="knob"></div>
</div>
